/* MYPOPMEE_MOBILE_UX_20261022 — présentation mobile uniquement.
   1) Le bouton principal n'affiche jamais un prix seul (« 29,90 € ») : l'action est ajoutée devant.
   2) Barre d'action collante en bas d'écran sur mobile, qui RELAIE le vrai bouton :
      - bouton actif  -> clic transmis au vrai bouton (mêmes gestionnaires, même contrat) ;
      - bouton bloqué -> défilement vers la prochaine étape à compléter (univers, photo, aperçu, validation).
   Aucun id, data-*, name, événement ni appel du générateur n'est modifié ou intercepté. */
(function () {
  'use strict';
  var real = document.getElementById('ppAddToCart');
  var label = document.getElementById('ppAddToCartLabel');
  var form = document.querySelector('.pp-info form.pp-form');
  var PRICE_ONLY = /^[\s ]*(?:[\d\s .,]+[\s ]*€|€[\s ]*[\d\s .,]+)[\s ]*$/;
  var lang = (document.documentElement.lang || 'fr').slice(0, 2);
  var ORDER = { fr: 'Commander — ', en: 'Order — ', de: 'Bestellen — ', es: 'Pedir — ', it: 'Ordina — ', nl: 'Bestellen — ' };
  var NEXT = { fr: 'Continuer', en: 'Continue', de: 'Weiter', es: 'Continuar', it: 'Continua', nl: 'Verder' };
  var STEP = {
    theme: { fr: 'Choisir mon univers', en: 'Choose my theme', de: 'Mein Thema wählen', es: 'Elegir mi universo', it: 'Scegli il mio tema', nl: 'Mijn thema kiezen' },
    photo: { fr: 'Ajouter ma photo', en: 'Add my photo', de: 'Mein Foto hinzufügen', es: 'Añadir mi foto', it: 'Aggiungi la mia foto', nl: 'Mijn foto toevoegen' },
    generate: { fr: 'Générer mon aperçu', en: 'Generate my preview', de: 'Vorschau erstellen', es: 'Generar mi vista previa', it: 'Genera la mia anteprima', nl: 'Mijn voorbeeld maken' },
    approve: { fr: 'Valider mon aperçu', en: 'Approve my preview', de: 'Vorschau bestätigen', es: 'Validar mi vista previa', it: 'Conferma l’anteprima', nl: 'Mijn voorbeeld goedkeuren' }
  };
  function t(o) { return o[lang] || o.fr; }
  var CREATE = { fr: 'Créer ma figurine', en: 'Create my figurine', de: 'Meine Figur gestalten', es: 'Crear mi figura', it: 'Crea la mia figurina', nl: 'Mijn figuur maken' };

  function orderPrefix() {
    var c = window.PP_MPM;
    return (c && c.i18n && c.i18n.order) || ORDER[lang] || ORDER.fr;
  }

  // 1) Libellé : jamais un prix seul.
  function fixLabel() {
    if (label && PRICE_ONLY.test(label.textContent)) label.textContent = orderPrefix() + label.textContent.trim();
  }
  if (label) {
    fixLabel();
    new MutationObserver(fixLabel).observe(label, { childList: true, characterData: true, subtree: true });
  }

  // 2) Barre collante (mobile uniquement, fiches produit avec configurateur).
  if (!form) return;
  var mq = window.matchMedia('(max-width: 749px)');
  var bar = document.createElement('div');
  bar.className = 'mx-sticky';
  bar.setAttribute('aria-hidden', 'true');
  bar.innerHTML = '<div class="mx-sticky__info"><span class="mx-sticky__title"></span><span class="mx-sticky__price"></span></div>' +
    '<button type="button" class="mx-sticky__btn" tabindex="-1"></button>';
  document.body.appendChild(bar);
  var bTitle = bar.querySelector('.mx-sticky__title');
  var bPrice = bar.querySelector('.mx-sticky__price');
  var bBtn = bar.querySelector('.mx-sticky__btn');
  var titleEl = document.querySelector('.pp-info .pp-title');
  var priceEl = document.getElementById('ppPrice');

  function madeMineBtn() {
    return document.querySelector('#ppMadeMineSlot .__button, #ppMadeMineSlot button, #mademine-node .__button');
  }
  function visible(el) { return !!(el && el.offsetParent !== null && !el.hidden); }

  // Prochaine étape à compléter quand le vrai bouton est bloqué.
  function nextStep() {
    var theme = document.getElementById('ppThemeSelector');
    if (theme && visible(theme) && !theme.querySelector('.pp-theme-option.active')) return { el: theme, txt: t(STEP.theme) };
    var zone = document.getElementById('ppUploadZone');
    if (zone && visible(zone) && !zone.classList.contains('has-file')) return { el: zone.closest('.pp-photo-required') || zone, txt: t(STEP.photo) };
    var gen = document.getElementById('ppMpmGenerate');
    if (gen && visible(gen)) return { el: gen, txt: t(STEP.generate) };
    var ap = document.getElementById('ppMpmApprove');
    if (ap && visible(ap)) return { el: ap, txt: t(STEP.approve) };
    return { el: real || form, txt: '' };
  }

  var realInView = true, formStarted = false;
  function target() { return real || madeMineBtn(); }

  function render() {
    var tg = target();
    if (!tg || !mq.matches) { hide(); return; }
    var txt = real ? (label ? label.textContent : real.textContent) : (tg.textContent || '');
    txt = txt.replace(/\s+/g, ' ').trim();
    var blocked = !!(real && real.disabled);
    if (!real && !txt) txt = CREATE[lang] || CREATE.fr;
    bBtn.textContent = blocked ? (nextStep().txt || txt || t(NEXT)) : txt;
    bBtn.classList.toggle('is-step', blocked);
    bTitle.textContent = titleEl ? titleEl.textContent.replace(/\s+—\s+MyPopMee\s*$/i, '').trim() : '';
    bPrice.textContent = priceEl ? priceEl.textContent.trim() : '';
    var focusInField = document.activeElement && /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName);
    var overlay = [].some.call(document.querySelectorAll('.sc-wrapper-fixed, dialog[open]'), function (o) {
      var r = o.getBoundingClientRect(); return r.width > 0 && r.height > 0 && getComputedStyle(o).visibility !== 'hidden';
    });
    if (formStarted && !realInView && !focusInField && !overlay) show(); else hide();
  }
  function show() {
    if (bar.classList.contains('is-on')) return;
    bar.classList.add('is-on'); bar.setAttribute('aria-hidden', 'false'); bBtn.tabIndex = 0;
    document.body.classList.add('mx-sticky-on');
  }
  function hide() {
    if (!bar.classList.contains('is-on')) return;
    bar.classList.remove('is-on'); bar.setAttribute('aria-hidden', 'true'); bBtn.tabIndex = -1;
    document.body.classList.remove('mx-sticky-on');
  }

  bBtn.addEventListener('click', function () {
    var tg = target();
    if (!tg) return;
    if (real && real.disabled) {
      var s = nextStep().el;
      var y = s.getBoundingClientRect().top + window.pageYOffset - 84;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      return;
    }
    tg.click(); // le vrai bouton garde son gestionnaire et son contrat
  });

  if ('IntersectionObserver' in window) {
    var watchReal = function () {
      var tg = target();
      if (!tg) return false;
      new IntersectionObserver(function (es) { realInView = es[0].isIntersecting; render(); }, { rootMargin: '0px 0px -40px 0px' }).observe(tg);
      return true;
    };
    new IntersectionObserver(function (es) {
      var e = es[0];
      formStarted = e.isIntersecting || e.boundingClientRect.top < 0;
      render();
    }).observe(form);
    if (!watchReal()) {
      // Bouton MadeMine injecté plus tard : on attend son arrivée (10 s max).
      var mo = new MutationObserver(function () { if (watchReal()) { mo.disconnect(); render(); } });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 10000);
    }
  }
  if (real) new MutationObserver(render).observe(real, { attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true });
  if (priceEl) new MutationObserver(render).observe(priceEl, { childList: true, characterData: true, subtree: true });
  new MutationObserver(function () { if (bar.classList.contains('is-on') || !realInView) render(); })
    .observe(document.body, { childList: true, attributes: true, attributeFilter: ['class', 'style'], subtree: false });
  // Ouverture / fermeture du calque MadeMine (DOM imbriqué) : réévaluation après chaque tap.
  document.addEventListener('click', function () { setTimeout(render, 450); setTimeout(render, 1500); }, true);
  document.addEventListener('focusin', render);
  document.addEventListener('focusout', function () { setTimeout(render, 50); });
  if (mq.addEventListener) mq.addEventListener('change', render);
  render();
})();
